import React, { useRef, useState } from 'react'
import Chart from 'react-apexcharts'
import Select from 'react-select'
import ApexCharts from 'apexcharts'
import { IDadosGraficosResultadosPorDimensaoPesquisaModel } from '../helpers/AnaliseResultadoHelper'
import { ISelectModel } from '../../../../modules/services/core/_models'

type Props = {
  dadosGraficosPesquisa: IDadosGraficosResultadosPorDimensaoPesquisaModel | undefined
  dimensoes: ISelectModel[]
  setDimensao: Function
  perguntas: ISelectModel[]
  setPergunta: Function
  perguntaSelecionada: ISelectModel | undefined
}

const GraficoResultadosGlobaisPorPergunta = ({
  dadosGraficosPesquisa,
  dimensoes,
  setDimensao,
  perguntas,
  setPergunta,
  perguntaSelecionada
}: Props) => {
  const chartRef = useRef<any>(null)
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const downloadChart = (format: 'png' | 'jpeg') => {
    ApexCharts.exec('grafico-unico', 'dataURI').then((res: { imgURI: string }) => {
      const link = document.createElement('a')
      link.href = res.imgURI
      link.download = `grafico.${format}`
      link.click()
    })
  }

  let stackType: any = '100%'   

  const options = {
    colors: dadosGraficosPesquisa?.Colors ?? [],
    series: dadosGraficosPesquisa?.Series ?? [],
    chart: {
      id: 'grafico-unico',
      toolbar: {
        show: false // ocultamos o padrão para usar o customizado
      },
      stacked: true,
      stackType: stackType, 
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: dadosGraficosPesquisa?.Categories ?? []
    },
    fill: {
      opacity: 1
    },
    legend: {
      offsetX: 40,
      inverseOrder: true
    }
  }

  return (
    <>
      <div className={`card m-0 p-0 ${dadosGraficosPesquisa ? '' : 'd-none'}`}>
        <div className='card-body m-0 p-0'>
          <div className="row justify-content-between m-0 p-5 pb-3 g-5">
            <div className='fv-row col-lg-4'>
              <label className='form-label text-gray-800'>Selecione a dimensão</label>
              {dimensoes.length > 0 && (
                <Select
                  placeholder='Selecione...'
                  className='form-control-custom-select'
                  noOptionsMessage={() => 'Nenhuma opção encontrada'}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      border: 'none',
                      backgroundColor: '$input-solid-bg',
                      borderRadius: '7px',
                      height: '3.4rem',
                      color: '#5e6278',
                      fontSize: '1.15rem'
                    }),
                    menu: (baseStyles) => ({
                      ...baseStyles,
                      backgroundColor: '#F9F9F9'
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      color: state.isFocused ? 'black' : '$input-solid-color'
                    })
                  }}
                  options={dimensoes.map((data) => ({
                    value: data.Id,
                    label: data.Nome
                  }))}
                  defaultValue={{
                    value: dimensoes[0].Id,
                    label: dimensoes[0].Nome
                  }}
                  isSearchable
                  onChange={(e: any) => setDimensao(e)}
                />
              )}
            </div>

            <div className='fv-row col-lg-7'>
              <label className='form-label text-gray-800'>Selecione a pergunta</label>
              {perguntas.length > 0 && (
                <Select
                  placeholder='Selecione...'
                  className='form-control-custom-select'
                  noOptionsMessage={() => 'Nenhuma opção encontrada'}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      border: 'none',
                      backgroundColor: '$input-solid-bg',
                      borderRadius: '7px',
                      height: '3.4rem',
                      color: '#5e6278',
                      fontSize: '1.15rem'
                    }),
                    menu: (baseStyles) => ({
                      ...baseStyles,
                      backgroundColor: '#F9F9F9'
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      color: state.isFocused ? 'black' : '$input-solid-color'
                    })
                  }}
                  options={perguntas.map((data) => ({
                    value: data.Id,
                    label: data.Texto
                  }))}
                  value={
                    perguntaSelecionada === undefined
                      ? {
                          value: perguntas[0].Id,
                          label: perguntas[0].Texto
                        }
                      : {
                          value: perguntaSelecionada.Id,
                          label: perguntaSelecionada.Nome
                        }
                  }
                  isSearchable
                  onChange={(e: any) => setPergunta(e)}
                />
              )}
            </div>

            {/* Botão de download personalizado estilo "☰" */}
            <div className='fv-row col-lg-1 d-flex align-items-end justify-content-lg-end'>
              <div className="dropdown">
                <button
                  className="btn btn-light btn-sm dropdown-toggle"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  ☰
                </button>
                <div
                  className={`dropdown-menu dropdown-menu-end ${dropdownOpen ? 'show' : ''}`}
                  style={{ minWidth: '160px' }}
                >
                  <button className="dropdown-item" onClick={() => downloadChart('png')}>
                    Baixar PNG
                  </button>
                  <button className="dropdown-item" onClick={() => downloadChart('jpeg')}>
                    Baixar JPEG
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className='row justify-content-center m-0 p-0'>
            <Chart
              ref={chartRef}
              options={options}
              series={options.series}
              type="bar"
              height={'400px'}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export { GraficoResultadosGlobaisPorPergunta }
